// Activity tracking utility for admin dashboard
export const ActivityTracker = {
  // Add a new activity to the system
  addActivity(type, message, metadata = {}) {
    const activity = {
      id: Date.now() + Math.random(),
      type,
      message,
      timestamp: new Date(),
      metadata
    };

    // Get existing activities
    const existing = this.getActivities();

    // Add new activity to the beginning and limit to 50 recent activities
    const updated = [activity, ...existing].slice(0, 50);

    // Save to localStorage
    localStorage.setItem('recentActivity', JSON.stringify(updated));

    return activity;
  },

  // Get all activities
  getActivities() {
    try {
      const stored = localStorage.getItem('recentActivity');
      if (stored) {
        const activities = JSON.parse(stored);
        return activities.map(a => ({
          ...a,
          timestamp: new Date(a.timestamp)
        }));
      }
    } catch (error) {
      console.error('Error loading activities:', error);
    }
    return [];
  },

  // Track user login
  trackLogin(userEmail, userName, companyName, userType = 'client') {
    const message = userType === 'admin'
      ? `Admin ${userName} logged in`
      : `${userName} from ${companyName} logged in`;

    return this.addActivity('login', message, {
      userEmail,
      userName,
      companyName,
      userType
    });
  },

  // Track file upload
  trackFileUpload(fileName, uploaderName, targetClient, fileSize) {
    const message = `${uploaderName} uploaded "${fileName}" for ${targetClient}`;
    return this.addActivity('upload', message, {
      fileName,
      uploaderName,
      targetClient,
      fileSize
    });
  },

  // Track client file upload (when clients upload their own files)
  trackClientFileUpload(fileName, clientName, companyName, fileSize) {
    const message = `${clientName} from ${companyName} uploaded "${fileName}"`;
    return this.addActivity('client-upload', message, {
      fileName,
      clientName,
      companyName,
      fileSize
    });
  },

  // Track new client addition
  trackClientAdded(clientName, addedBy) {
    const message = `New client "${clientName}" added by ${addedBy}`;
    return this.addActivity('client', message, {
      clientName,
      addedBy
    });
  },

  // Track user invitation
  trackUserInvitation(invitedEmail, invitedBy, companyName) {
    const message = `${invitedBy} invited ${invitedEmail} to ${companyName}`;
    return this.addActivity('user', message, {
      invitedEmail,
      invitedBy,
      companyName
    });
  },

  // Clear all activities (for testing/reset)
  clearActivities() {
    localStorage.removeItem('recentActivity');
  }
};

export default ActivityTracker;